const initialState = {
    active: false
};

const PushMenuReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'OPEN_PUSH_MENU':
            return Object.assign({}, state, {active: true});

        case 'CLOSE_PUSH_MENU':
            return Object.assign({}, state, {active: false});

        default:
            return state;
    }
};

export default PushMenuReducer;


// WEBPACK FOOTER //
// ./src/reducers/PushMenu.js